module.exports = __webpack_public_path__ + "img/berts-point-reward.f2cecb2f.svg";